<template>
  <div>
    <v-form ref="documentForm">
      <v-row dense>
        <v-col
          cols="12"
          md="4"
        >
          <label class="cmr-label-text">Select Document</label>
          <v-combobox
            :rules="requiredRule"
            outlined
            clearable
            clear-icon="mdi-close"
            v-model="documentType"
            :items="documentsTypesList"
            dense
          ></v-combobox>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <label class="cmr-label-text">Expiry Date</label>
          <DateInputIconV2
            :rules="requiredRule"
            :required="true"
            v-model="dateForNewDocument"
            :clearable="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <FileInput
            :rules="requiredRule"
            label="Upload Document"
            icon="insert_drive_file"
            accept="*"
            @fileInput="handleDocumentInput"
          />
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col>
          <v-btn small @click="uploadDocument">Submit</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DateInputIconV2 from '../widget/input/DateInputIconV2'
import FileInput from "@/components/widget/input/FileInputV2.vue";
import axios from 'axios'

export default {
  name: "AnyDocumentUploadBox",
  components: {DateInputIconV2, FileInput},
  props: {
      driverId: {
        type: Object,
        default: null
      },
      documentTypes: {
        default: null,
        type: Array
      },
    taxiId: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      requiredRule: [(v) => !!v || "Field is required"],
      dateForNewDocument: new Date().toISOString().substr(0, 10),
      uploadedFile: null,
      documentType: null,
      fetchedDriverDocumentURL: null,
      fetchedDriverDocument: null,
      serverItemsLength: null,
      selectedItem: null,
      viewFileDialog: false,
    }
  },
  computed: {
    documentsTypesList () {
      let docs = []
      this.documentTypes.forEach(doc => {
        docs.push(doc.type)
      })
      return docs
    }
  },
  methods: {
    handleDocumentInput(file) {
      this.uploadedFile = file;
    },
    async submitDocument() {
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_document_expiry/upload_document`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
      
        if (response.data.error == "no_error") {
          this.viewFileDialog = false;
          this.$emit('documentProcessed')
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    async uploadDocument() {
      if (!this.$refs.documentForm.validate()) {
        return false
      }
    
      console.log(this.uploadedFile);
      let document = {
        document_type: this.documentType,
        file: this.uploadedFile,
        expiry_time: this.dateForNewDocument,
        driver_id: this.driverId,
        taxi_id: this.taxiId
      }

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_document_expiry/upload_document`,
          document,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
      
        if (response.data.error == "no_error") {
          this.$refs.documentForm.reset()
          this.$emit('documentUploaded')
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    },
    reject() {
      this.verdict(false);
    },
    accept() {
      if (this.uploadedFile != null) {
        this.uploadDocument();
      } else {
        this.verdict(true);
      }
    },
  }
}
</script>

<style scoped>

</style>